import { useState } from 'react';
import {
  type EnumContentSize,
  useLocalTableContentSize,
} from './useLocalTableContentSize.ts';

/**
 * Hook per gestire lo stato di visualizzazione del contenuto della tabella
 * (FULL / BOXED)
 */
export function useTableContentSize(key: string) {
  const [currentContentSize, setCurrentContentSize] =
    useState<EnumContentSize | null>(null);
  const { contentSize } = useLocalTableContentSize(key, currentContentSize);

  return {
    contentSize,
    setContentSize: setCurrentContentSize,
  };
}
